import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 0.6rem;
  margin-bottom: 1rem;
  margin-bottom: 1rem;
`;

const SpecialSpacing = styled.div`
  padding: 0.5rem 0rem;
  display: flex;
  justify-content: space-between;
  &&.time-line {
    align-items: flex-end;
  }
  .separator {
    padding: 0rem 1rem;
    padding-top: 7px;
  }
`;

const SpecialSpacingHr = styled(SpecialSpacing)`
  border-bottom: 1px solid #dbdbdb;
`;

const LoginTableDetails = ({ logObject, refreshButton, children }) => {
  const [isActiveOrderDisplayed, setIsActiveOrderDisplayed] = React.useState(
    false,
  );
  return (
    <>
      {children({
        data: logObject?.['Orders Displayed'],
        open: isActiveOrderDisplayed,
        onClose: () => setIsActiveOrderDisplayed(false),
      })}
      <Container>
        {Object.keys(logObject ?? {})
          .filter(ele => ele !== 'Orders Displayed')
          .map(ele => (
            <SpecialSpacingHr>
              <p className="is-size-3 has-text-weight-semibold">{ele}</p>
              <p className="is-size-3 has-text-weight-semibold">{`${logObject[ele]}`}</p>
            </SpecialSpacingHr>
          ))}
        {logObject?.['Orders Displayed'] ? (
          <SpecialSpacingHr>
            <p className="is-size-3 has-text-weight-semibold">
              Orders Not Displayed
            </p>
            <button
              onClick={() => setIsActiveOrderDisplayed(true)}
              className="button is-text is-size-3 has-text-weight-semibold"
            >
              Click to view
            </button>
          </SpecialSpacingHr>
        ) : (
          <SpecialSpacingHr>
            <p className="is-size-3 has-text-weight-semibold">
              Orders Displayed
            </p>
            <p className="is-size-3 has-text-weight-semibold">-</p>
          </SpecialSpacingHr>
        )}
        <SpecialSpacingHr>{refreshButton()}</SpecialSpacingHr>
      </Container>
    </>
  );
};

export default LoginTableDetails;
